import styled from 'styled-components';
import { Tooltip } from '../TooltipText/styles';

export const Conteiner = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  width: 100%;
`;

export const Titulo = styled.span``;

export const ConteinerInputs = styled.div`
  display: flex;

  width: 100%;
`;

export const BordaDeFoco = styled.span`
  position: absolute;
  top: 50px;

  width: ${(props) => (props.error ? '100%' : 0)};
  height: 2px;

  background-color: ${(props) => (props.error ? props.theme.DANGER : props.theme.PRIMARY)};
  bottom: 0;

  transition: 0.4s;
`;

export const CampoInput = styled.input`
  display: ${(props) => (props.invisible ? 'none' : 'block')};

  width: 100%;
  padding: 7px 0 1px 0;

  color: ${(props) => props.theme.DARK};
  background-color: ${(props) => props.theme.MEDIUM};
  border: 0;
  border-bottom: 1px solid #ccc;
  box-sizing: border-box;

  font:
    15px/24px 'Lato',
    arial,
    sans-serif;
  letter-spacing: 1px;

  &:focus {
    outline: none;
    outline-offset: 0;
  }

  &:focus ~ ${BordaDeFoco} {
    width: 100%;
  }

  &:disabled {
    opacity: 0.7;
  }
`;

export const ConteinerIcone = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  padding: 0 10px;

  background-color: ${(props) => props.theme.MEDIUM};
  border-bottom: 1px solid #ccc;

  cursor: ${(props) => (props.disabled ? 'unset' : 'pointer')};

  &:hover ${Tooltip} {
    visibility: visible;
    opacity: 1;
  }
`;

export const TextoDeErro = styled.span`
  color: ${(props) => props.theme.DANGER};
`;
